import cashierIcon from '@ezugi/static/icons/cashier.svg';
import { getThemeColor } from '@ezugi/ui/theme';

export const closeButton = {
  transparent: true,
  background: getThemeColor('alert'),
  lowercase: true,
  sparse: true,
};

export const cashierButton = {
  transparent: true,
  lowercase: true,
  sparse: true,
  accent: true,
  icon: cashierIcon,
};

export const continueButton = {
  transparent: true,
  lowercase: true,
  sparse: true,
  background: getThemeColor('alert'),
};

export const reconnectButton = {
  transparent: true,
  lowercase: true,
  sparse: true,
  accent: true,
};

export const refreshButton = {
  transparent: true,
  lowercase: true,
  sparse: true,
  accent: true,
};

export const homeButton = {
  transparent: true,
  background: getThemeColor('alert'),
  lowercase: true,
  sparse: true,
};

export const okButton = {
  transparent: true,
  lowercase: false,
  sparse: true,
  background: '#1db1f9',
};

export const UKGCContinue = {
  transparent: true,
  lowercase: false,
  background: '#1db1f9',
};
export const UKGCHistory = {
  transparent: true,
  lowercase: false,
  background: getThemeColor('alert'),
};
export const UKGCLogOut = {
  transparent: true,
  lowercase: false,
  background: '#fff',
};
